var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1014_804)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1014_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.75 1.5L18.25 9L24.25 11.25L13.75 22.5L15.25 15L9.25 12.75L19.75 1.5Z",
    stroke: "#263322",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 30.75,
    cy: 2,
    r: 1.5,
    fill: "#9AECBF",
    stroke: "#263322"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1014_804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 34.0513,
    fill: "white",
    transform: "translate(0.75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1014_804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/Activity.5098de6095d170a1c3dcac35c7fe0e55.svg";
export { ForwardRef as ReactComponent };